import { z } from 'zod';

const optionalDateInterval = {
  from: z.date().optional(),
  to: z.date().optional(),
};

export const formSchema = z.object({
  supplierId: z.array(z.string()).optional(),
  companyId: z.array(z.string()).optional(),
  invoiceNumber: z.string().optional(),
  emissionDate: z.object(optionalDateInterval).optional(),
  deadlineDate: z.date().optional(),
  carrierId: z.array(z.string()).optional(),
  sameCarrierCnpj: z.boolean().optional(),
  originUf: z.string().optional(),
  originIbge: z.string().optional(),
  destinationUf: z.string().optional(),
  destinationIbge: z.string().optional(),
  indicatorStatus: z.array(z.string()).optional(),
});

export type FormSchema = z.infer<typeof formSchema>